/**
 * Returns a color code for a given stage type
 * @param stageType The stage type string
 * @returns Hex color code
 */
export function getStageTypeColor(stageType: string): string {
    switch (stageType) {
        case 'INTRODUCED': return '#1890ff'; // Blue
        case 'INTERVIEW': return '#52c41a';  // Green  
        case 'OFFERED': return '#faad14';    // Yellow
        case 'HIRED': return '#13c2c2';      // Cyan
        case 'REJECTED': return '#ff4d4f';   // Red
        case 'ON_HOLD': return '#722ed1';    // Purple
        default: return '#d9d9d9';           // Grey
    }
} 